import dayjs from 'dayjs';
import jalaliday from 'jalali-plugin-dayjs';

import 'dayjs/locale/fa';

dayjs.extend(jalaliday);
dayjs.locale('fa');
